import "./style.css";

export default function FormActions({
  editing = true,
  onEdit,
  onCancel,
  onSave,
  saveType = "button",
  saving = false,
  disabled = false,
  editLabel = "Editar",
  cancelLabel = "Cancelar",
  saveLabel = "Salvar",
  savingLabel = "Salvando...",
  className = "",
}) {
  const hasEditMode = typeof onEdit === "function";
  const actionClassName = `admin-form-actions ${className}`.trim();

  if (hasEditMode && !editing) {
    return (
      <div className={actionClassName}>
        <button
          type="button"
          className="admin-form-actions__edit"
          onClick={onEdit}
          disabled={disabled}
        >
          {editLabel}
        </button>
      </div>
    );
  }

  return (
    <div className={actionClassName}>
      <button
        type="button"
        className="admin-form-actions__cancel"
        onClick={onCancel}
        disabled={disabled || saving}
      >
        {cancelLabel}
      </button>
      <button
        type={saveType}
        className="admin-form-actions__save"
        onClick={saveType === "button" ? onSave : undefined}
        disabled={disabled || saving}
      >
        {saving ? savingLabel : saveLabel}
      </button>
    </div>
  );
}
